import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface Book {
  path: string
  imageUrl: string
  title: string
  contentCount: number
  description: string
}

interface BookCardProps {
  book: Book
  company?: string
  used?: string
}

export default function BookCard({ book, company, used = '' }: BookCardProps) {
  return (
    <Link href={book.path} className={clsx(styles.bookLink, used)}>
      <div className={styles.bookCard}>
        <div className={styles.bookImage}>
          <img
            src={book.imageUrl}
            width={200}
            height={300}
            className={styles.bookContentImage}
            alt={book.title}
            loading='lazy'
          />
        </div>
        <div className={styles.bookContents}>
          <div className={styles.bookContentHead}>
            <h2 className={styles.bookTitle}>{book.title}</h2>
            <p className={styles.bookCountWrapper}>
              <span className={styles.bookCount}>{book.contentCount}</span>
            </p>
          </div>
          <div className={styles.bookContentBody}>
            <p className={styles.bookCopy}>{book.description}</p>
            {company && <p className={styles.bookCompany}>{company}</p>}
          </div>
        </div>
      </div>
    </Link>
  )
}
